module.exports = __webpack_public_path__ + "static/media/teen-burger-desktop-399_en.0b60336c.jpg";